import { html, TemplateResult, nothing } from 'lit';
import { translateFn } from '../../../../utils/translator.helper';
import { BaseSpecificDetailsView } from '../../specificDetailViewByType/baseSpecificDetailsView';
import { UNAVAILABLE_DATA } from '../../../types';

export class DiscoveredDomainsView extends BaseSpecificDetailsView {
  static getGeneralInfo(data: any, dependencies: any): TemplateResult {
    return html`
      <gz-labeled-content label="${translateFn('Domain')}" class="labeled-row" labelFontSize="14">
        <div class="d-flex align-items-center item-with-action">
          <gz-tooltip tooltipText="${data.domain ?? UNAVAILABLE_DATA}" isEllipsis>${data.domain ?? UNAVAILABLE_DATA}</gz-tooltip>
          ${data.domain
            ? html`
                <gz-copy-to-clipboard
                  class="icon-right-action"
                  .confirmationMessage="${translateFn('Copied')}"
                  .clipboardMessage="${data.domain}"
                >
                </gz-copy-to-clipboard>
              `
            : nothing}
        </div>
      </gz-labeled-content>
    `;
  }
}
